module.exports = __webpack_public_path__ + "static/media/en-data-roaming-other_3.dca1021f.png";